import FieldStateEnum from '@src/utils/enums/fieldStateEnum';

export default {
  data: () => ({
    internalValue: '',
  }),
  computed: {
    maxLengthValue() {
      return this[this.fieldKey].maxlength || this.maxlength;
    },
  },
  mounted() {
    this.setTextValue();
    this.setCounterValue();
  },
  methods: {
    inputChanged(e) {
      this.setFieldState(FieldStateEnum.input);
      const val = e.target.value;
      this[this.fieldKey].value = val;
      this.$emit('update:value', val);
    },
    setTextValue() {
      this.internalValue = this.value || this.internalValue;
      this[this.fieldKey].value = this[this.fieldKey].value || this.internalValue;
    },
    setCounterValue() {
      this[this.fieldKey].counter = this[this.fieldKey].counter || this.counter;
      this[this.fieldKey].maxlength = this[this.fieldKey].maxlength || this.maxlength;
    },
  },
};
